import onApproveDeleteRequest from './onApproveDeleteRequest';
import onRejectDeleteRequest from './onRejectDeleteRequest';
import onGetDeleteRequests from './onGetDeleteRequests';

export default {
  onApproveDeleteRequest,
  onGetDeleteRequests,
  onRejectDeleteRequest,
};
